import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-season-bag-new-filters',
	templateUrl: './season-bag-new-filters.component.html',
	styleUrls: ['./season-bag-new-filters.component.scss'],
})
export class SeasonBagNewFiltersComponent extends FiltersComponent {
	@Input() yesno: Array<any>;
	@Input() names: Array<any>;
	@Input() statuses: Array<any>;

	filters = {
		departure_time_after: null,
		departure_time_before: null,
		name: null,
		return_time_after: null,
		return_time_before: null,
		accommodation_after: null,
		accommodation_before: null,
		status: null,
		swinging: null,
		transport_departure_exists: null,
		transport_return_exists: null,
	};
}
